<template>
  <div class="newGroup">
    <MapModal
      class="newModelPosition"
      :modalNode="modalNode"
      :title="newGroupingCategory.title"
      :id="newGroupingCategory.id"
      :close="closeOneSelf"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="100px"
        >
          <el-form-item label="方案名称" prop="name">
            <el-input v-model="form.name" class="formName"></el-input>
          </el-form-item>
          <el-form-item label="显示路径" prop="showPath">
            <el-switch
              v-model="form.showPath"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeShowPath"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="控制全局速度" prop="isglobal">
            <el-switch
              v-model="form.isglobal"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeSpeed"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label=" " prop="roamSpeed">
            <el-radio-group
              v-model="form.roamSpeed"
              :disabled="!form.isglobal"
              size="small"
              @input="inputCustomize"
            >
              <el-radio :label="3">快</el-radio>
              <el-radio :label="8">中</el-radio>
              <el-radio :label="14">慢</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label=" " prop="roamSpeed">
            <el-radio
              v-model="customize"
              :disabled="!form.isglobal"
              class="formNum"
              @input="inputCustomize"
              label="customize"
            >
              自定义
              <el-input
                v-model="form.customSpeed"
                :disabled="!customize"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+2)}"
              ></el-input>
              m/s</el-radio
            >
          </el-form-item>
          <el-form-item class="submitBtn btns">
            <el-button @click="closeOneSelf">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import * as viewpointMap from "./viewpointMap.js";

export default {
  components: {
    MapModal,
  },
  data() {
    return {
      newGroupingCategory: {
        title: "新建方案",
        id: "newGroupingPage",
      },
      modalNode: {
        newGroupingCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -590,
          },
          // width: "450px", // 宽度配置 默认450px
          height: "355px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      rules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
        modelName: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
      form: {
        name: "",
        roamSpeed: 8,
        showPath: false,
        isglobal: true,
        customSpeed: 50,
      },
      customize: null,
    };
  },
  methods: {
    onSubmit() {
      if (this.customize) {
        this.form.customSpeed = Number(this.form.customSpeed);
        if (this.form.customSpeed <= 0) {
          this.$message({
            message: "自定义速度不能小于0",
            type: "warning",
          });
          return;
        }
      } else {
        this.form.customSpeed = 0;
      }
      this.$emit("onSubmitGroupName", this.form);
    },
    closeOneSelf() {
      this.$emit("closeNewGrouping");
    },
    changeSpeed(v) {
      this.speedShow = !v;
      this.customize = null;
      if (v) {
        this.form.roamSpeed = 8;
      } else {
        this.form.roamSpeed = null;
      }
    },
    changeShowPath(v) {
      if (v) {
        console.log(this.$parent.editTreeData);
        if (this.$parent.editTreeData.children.length) {
          viewpointMap.openPath(this.$parent.editTreeData.children);
        }
      } else {
        viewpointMap.clearPath();
      }
    },
    inputCustomize(v) {
      console.log(v);
      if (v == "customize") {
        this.form.roamSpeed = null;
      } else {
        this.customize = null;
      }
    },
  },
};
</script>

<style lang="scss" src="./newGroup.scss" scoped></style>
